/**
 * Autoplays product gallery videos when their slide becomes the active slide.
 * Targets only slides whose <deferred-media> has the [autoplay] attribute
 * (controlled by the "cc_video_autoplay" block setting).
 */
(() => {
  /**
   * @param {Element} slide
   */
  function playSlideVideo(slide) {
    const deferredMedia = slide.querySelector('deferred-media[autoplay]');
    if (!deferredMedia) return;

    if (deferredMedia.hasAttribute('data-media-loaded')) {
      if (typeof deferredMedia.playMedia === 'function' && !deferredMedia.isPlaying) {
        deferredMedia.playMedia();
      }
    } else if (typeof deferredMedia.showDeferredMedia === 'function') {
      deferredMedia.showDeferredMedia();
    }
  }

  /**
   * @param {Element} gallery
   * @param {Element} activeSlide
   */
  function pauseOtherVideos(gallery, activeSlide) {
    gallery.querySelectorAll('deferred-media[autoplay]').forEach((deferredMedia) => {
      if (deferredMedia.isPlaying && !activeSlide.contains(deferredMedia)) {
        deferredMedia.pauseMedia();
      }
    });
  }

  document.addEventListener('slideshow:select', (event) => {
    const gallery = event.target instanceof Element ? event.target.closest('media-gallery') : null;
    const slide = event.detail?.slide;
    if (!gallery || !slide) return;

    pauseOtherVideos(gallery, slide);
    playSlideVideo(slide);
  });

  function autoplayInitialSlides() {
    document.querySelectorAll('media-gallery slideshow-component').forEach((slideshow) => {
      const slides = slideshow.slides;
      const currentSlide = slides && slides[slideshow.current];
      if (currentSlide) playSlideVideo(currentSlide);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoplayInitialSlides);
  } else {
    autoplayInitialSlides();
  }
})();
